/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Box, Grid, Tabs, Tab, Slider, Typography, Button, Card, Dialog, DialogActions, DialogContent, Stack } from '@mui/material';
import EditorImage from './Components/Editor';
import EditorImagePreview from './Components/ImagePreview';
import FilterCards from './Components/FilterCards';
import { LanguageContext } from '../../../../../../libs/Context';
import { getBlobUrl, handleThumbnail, objectUrlToFile, s3DeleteNew, updateImgInS3 } from '../../../../../../libs/HelperContent';
import { createFeedContext } from '../CreationPopup';
import Loading from '../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { useSelector } from 'react-redux';

const TabPanel = ({ children, value, index, ...other }) => (
	<div
		role='tabpanel'
		hidden={value !== index}
		id={`tabpanel-${index}`}
		aria-labelledby={`tab-${index}`}
		style={{ width: 'var(--percent100)' }}
		{...other}
	>
		{value === index && <Box>{children}</Box>}
	</div>
);

const ImageEditor = (props) =>
{
	const { open, uploadedFiles, onClose, setUploadedFiles, handleCloseImgPop } = props;
	const [ tabIndex, setTabIndex ] = useState(0);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { language } = useContext(LanguageContext);
	const { setCreateFeed } = useContext(createFeedContext);
	const [ loading, setLoading ] = useState<any>(false);

	const initialState = {
		// ...uploadedFiles[0],
		brightness : 0,
		smoothness : 0,
		contrast   : 0,
		saturation : 0,
		zoom       : 100,
		filter     : 'none',
		HD         : false

	};

	const [ applyImgFilters, setApplyImgFilters ] = useState<any>({});

	const handleTabChange = (event, newValue) => setTabIndex(newValue);

	const handleSlctImg = (media) =>
	{
		const findInd = uploadedFiles?.findIndex((dataD) => dataD?.key === applyImgFilters?.key);

		const updatedD = [ ...uploadedFiles ];

		updatedD[findInd] = { ...updatedD[findInd], styles: { ...applyImgFilters?.styles } };

		setUploadedFiles(updatedD);

		setApplyImgFilters({ ...media });
	};

	const imageStyle: React.CSSProperties = {
		transform : `scale(${applyImgFilters?.styles?.zoom / 100})`,
		filter    : `
      brightness(${100 + applyImgFilters?.styles?.brightness}%)
      contrast(${100 + applyImgFilters?.styles?.contrast}%)
      saturate(${100 + applyImgFilters?.styles?.saturation}%)
      blur(${applyImgFilters?.styles?.smoothness}px)
      ${applyImgFilters?.styles?.filter !== 'none' ? applyImgFilters?.styles?.filter : ''}
      ${applyImgFilters?.styles?.HD ? 'contrast(120%) saturate(120%)' : ''}
    `,
		objectFit : 'contain',
		maxHeight : 'var(--percent100)',
		maxWidth  : 'var(--percent100)'
	};

	const handleRemoveFromS3 = async () =>
	{
		const removedItems = uploadedFiles?.length > 0 && uploadedFiles?.filter((item) => item?.tab === 2);

		setUploadedFiles(uploadedFiles?.filter((item) => item?.tab !== 2));

		if (removedItems?.length > 0)
		{
			Promise.all(removedItems?.map(async (mediaD) => await s3DeleteNew(mediaD?.key, '')));
		}

		onClose();
	};

	const updateFilters = (filterkey: string, value: number) =>
	{
		setApplyImgFilters((prevState) => ({
			...prevState, styles : { ...prevState?.styles, [filterkey]: value }

		}));
	};

	// Update Upload Files
	const updateUploadFiles = useCallback((media) =>
	{
		const findInd = uploadedFiles?.findIndex((dataD) => dataD?.key === media?.key);

		const updatedD = [ ...uploadedFiles ];

		updatedD[findInd] = media;

		setUploadedFiles(updatedD);
	}, [ applyImgFilters ]);

	// Step-4: Need do cross check file type and maintain their properties as it is on S3 side.
	const generateFilteredImg = (newImage, mediaObj, getImage, newObj) =>
	{
		return new Promise((resolve, reject) =>
		{
			newImage.onload = async () =>
			{
				try
				{
					// Check if the image is a GIF
					const isGif = getImage?.name?.toLowerCase().endsWith('.gif') ||
								getImage?.type === 'image/gif';

					let file;
					let newDataUrl;

					if (isGif)
					{
						// For GIFs, we'll apply CSS filters instead of canvas manipulation
						// Store the original file and add filter data as metadata
						const filterStyles = {
							zoom       : getImage?.styles?.zoom || 100,
							brightness : getImage?.styles?.brightness || 0,
							contrast   : getImage?.styles?.contrast || 0,
							saturation : getImage?.styles?.saturation || 0,
							smoothness : getImage?.styles?.smoothness || 0,
							filter     : getImage?.styles?.filter || 'none',
							HD         : getImage?.styles?.HD || false
						};

						// Convert the original image to a file
						const response = await fetch(newImage.src);
						const blob = await response.blob();

						file = new File([ blob ], getImage?.name, { type: 'image/gif' });

						// Store filter data in the mediaObj for frontend rendering
						mediaObj.filterStyles = filterStyles;
					}
					else
					{
						// Original canvas-based processing for non-GIF images
						const canvas = document.createElement('canvas');
						const ctx:any = canvas.getContext('2d');

						const { zoom, brightness, contrast, saturation, smoothness, filter, HD } = getImage?.styles;
						const zoomFactor = zoom / 100 || 1;

						canvas.width = newImage.width;
						canvas.height = newImage.height;

						ctx.filter = `
							brightness(${100 + brightness}%)
							contrast(${100 + contrast}%)
							saturate(${100 + saturation}%)
							blur(${smoothness}px)
							${filter !== 'none' ? filter : ''}
							${HD ? 'contrast(120%) saturate(120%)' : ''}
						`;

						ctx.scale(zoomFactor, zoomFactor);
						ctx.fillRect(0, 0, canvas.width, canvas.height);
						ctx.drawImage(newImage, 0, 0);

						newDataUrl = canvas.toDataURL('image/jpeg');
						file = await objectUrlToFile(newDataUrl, getImage?.name);
					}

					const match = getImage?.key?.match(/^([^/]+\/[^/]+\/)/);

					const result = match ? match[1] : '';

					const key = getImage?.key?.split('/')?.pop();

					const updateS3 = await updateImgInS3(key, file, result);
					const thumbnail = await handleThumbnail(file, {
						public : `${userData?.companyId}/feed/`
					});

					resolve({
						...newObj,
						...mediaObj,
						key    : updateS3?.key,
						height : newImage?.height,
						width  : newImage?.width,
						thumbnail
					});
				}
				catch (error)
				{
					reject(error);
				}
			};

			newImage.onerror = () =>
			{
				reject(new Error('error filtered'));
			};
		});
	};

	// Step-2: Uploaded File gettting evaluted here... for final call.
	const uploadFilteredImgs = async () =>
	{
		setLoading(true);
		const newS3Data = await Promise.all(
			uploadedFiles?.map(async (mediaObj:any) =>
			{
				const findSlctdImg = mediaObj?.key === applyImgFilters?.key;

				const getImage = findSlctdImg ? applyImgFilters : mediaObj;

				const newObj = {
					existImg : await getBlobUrl(getImage?.key)
				};

				const newImage = new Image();

				newImage.src = getImage?.dataUrl;

				// Step-3: From getting files from uploaded files, need to genrate filtered files as per the media type.
				return await generateFilteredImg(newImage, mediaObj, getImage, newObj);
			})
		);

		setLoading(false);

		setCreateFeed((prev) => ({ ...prev, media: [ ...(prev.media ?? []), ...(newS3Data ?? []) ] }));

		handleCloseImgPop();
	};

	const slidersData = [
		{ id: 1, language: language?.brightness, min: -100, max: 100, key: 'brightness', label: 'Brightness' },
		{ id: 2, language: language?.smoothness, min: 0, max: 10, key: 'smoothness', label: 'Smoothness' },
		{ id: 3, language: language?.contrast, min: -100, max: 100, key: 'contrast', label: 'Contrast' },
		{ id: 4, language: language?.saturation, min: -100, max: 100, key: 'saturation', label: 'Saturation' },
		{ id: 5, language: language?.zoom, min: 100, max: 300, key: 'zoom', label: 'Zoom' }
	];

	// Step-1: When UploadFiles gets updated, It'll trigger here.
	useEffect(() =>
	{
		const getBloburls = async () =>
		{
			setLoading(true);
			const fetchUrls = await Promise.all(
				uploadedFiles?.map(async (mediaD:any) => ({
					...mediaD,
					dataUrl : await getBlobUrl(mediaD?.key),
					styles  : initialState

				})));

			setUploadedFiles(fetchUrls);

			setApplyImgFilters((prev) => ({ ...prev, ...fetchUrls[0] }));
			setLoading(false);
		};

		getBloburls();
	}, []);

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
			<DialogContent>
				{loading && <Loading/>}
				<Box
					sx={{
						display       : 'flex',
						flexDirection : 'column',
						overflow      : {
							xs : 'auto',
							sm : 'hidden'
						},
						position : 'relative'
					}}
				>
					<Grid container spacing={2} alignItems={'start'} justifyContent={'start'} >
						<EditorImage
							imageStyle={imageStyle}
							applyImgFilters={applyImgFilters}
							setApplyImgFilters={setApplyImgFilters}
							updateUploadFiles={updateUploadFiles}
							initialState={initialState}

						/>
						<Grid
							item
							xs={12}
							md={5}
							sx={{
								display        : 'flex',
								justifyContent : 'start',
								flexDirection  : 'column',
								alignItems     : 'start'
							}}
						>
							<Tabs value={tabIndex} onChange={handleTabChange} sx={{ padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
								<Tab label={language?.adjust} sx={{ padding        : '6px',
									display        : 'flex',
									alignItems     : 'center',
									 justifyContent : 'start',
									minHeight      : 'var(--pixel20)' }}
								/>
								<Tab label={language?.filters} sx={{ padding        : '6px',
									display        : 'flex',
									alignItems     : 'center',
									justifyContent : 'start',
									minHeight      : 'var(--pixel20)' }}
								/>
							</Tabs>
							<TabPanel sx={{ width: 'var(--percent100)' }} value={tabIndex} index={0} >
								<Card
									sx={{
										paddingX      : 'var(--pixel12)',
										paddingBottom : 'var(--pixel8)',
										width         : 'var(--percent100)',
										height        : 'var(--percent100)'
									}}
								>
									<Grid container spacing={2} p='var(--pixel16)'>
										{slidersData?.map((sliderD:any) =>
											(
												<Grid item xs={12} key={sliderD?.id}
													display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'center'} gap={1}
												>
													<Typography fontSize='var(--pixel12)' fontWeight='var(--font500)' pb='var(--pixel4)'>{sliderD?.language}</Typography>
													{/* <CustomSlider
														value={applyImgFilters?.styles?.[sliderD?.key] ?? 0}
														onChange={(e, val) =>
															updateFilters(sliderD?.key, Array.isArray(val) ? val[0] : val)}
														aria-label={sliderD?.label}
														min={sliderD?.min}
														max={sliderD?.max}
														size='small'
														valueLabelDisplay='auto'
														sx={{ width: '100%', padding: '0' }}
													/> */}
													<Slider
														value={applyImgFilters?.styles?.[sliderD?.key] ?? 0}
														onChange={(e, val) =>
															updateFilters(sliderD?.key, Array.isArray(val) ? val[0] : val)}
														aria-label={sliderD?.label}
														min={sliderD?.min}
														max={sliderD?.max}
														size='small'
														valueLabelDisplay='auto'
														sx={{ width: 'var(--percent100)', padding: '0' }}
													/>
												</Grid>

											))	}
									</Grid>
								</Card>

							</TabPanel>
							<TabPanel value={tabIndex} index={1}>
								<FilterCards
									applyImgFilters={applyImgFilters}
									updateFilters={updateFilters}
								/>
							</TabPanel>
						</Grid>
					</Grid>
					<EditorImagePreview
						uploadedFiles={uploadedFiles}
						handleSlctImg={handleSlctImg}
						applyImgFilters={applyImgFilters}
						setUploadedFiles={setUploadedFiles}
						initialState={initialState}
					/>
				</Box>
			</DialogContent>

			<DialogActions sx={{ width: 'var(--percent100)' }}>
				<Stack direction={'row'} spacing={2} px='var(--pixel16)' pb='var(--pixel8)'>
					<Button variant='outlined' onClick={handleRemoveFromS3}>
						{language?.cancel}
					</Button>
					<Button variant='contained' sx={{ color: 'var(--whiteColor)' }} onClick={uploadFilteredImgs}>
						{language?.add}
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default ImageEditor;